<template>
  <section :class="embedded ? 'mr-booking-embed' : 'dp-layout mr-page-layout'">
    <section :class="embedded ? '' : 'dp-right mr-module'">
      <div v-if="!embedded" class="page-header">
        <div>
          <div class="header-title-bar">
            <span class="header-icon-bar"></span>
            <h3>代订会议</h3>
          </div>
          <p class="page-desc">管理员为学校教职工创建会议；教师日常自助预约请使用钉钉 H5</p>
        </div>
        <el-tag v-if="schoolName" type="success" size="medium" effect="plain" class="school-badge">
          <i class="el-icon-school"></i> {{ schoolName }}
        </el-tag>
        <span v-else-if="!schoolId" class="school-hint">请在顶部选择学校</span>
      </div>

      <div v-if="!schoolId" class="empty-tip">请在顶部选择学校后创建会议</div>

      <el-card v-else shadow="never" :class="['mr-panel', 'mr-booking-panel', { 'is-embedded': embedded }]">
        <div v-if="embedded" class="mr-booking-panel-inner is-embedded">
          <div class="mr-booking-tab-scroll is-form-scroll">
            <el-form ref="form" :model="form" :rules="formRules" label-width="100px" size="small"
              class="mr-booking-form">
              <el-form-item label="会议室" prop="RoomId">
                <el-select v-model="form.RoomId" filterable placeholder="请选择会议室" style="width: 100%;"
                  :loading="roomLoading" @visible-change="loadRooms">
                  <el-option v-for="r in roomOptions" :key="r.Id" :label="roomOptionLabel(r)" :value="r.Id" />
                </el-select>
              </el-form-item>
              <el-form-item label="预约人" prop="BookerTeacherMasterId">
                <MeetingRoomTeacherSelect v-model="form.BookerTeacherMasterId" :department-id="schoolId" />
              </el-form-item>
              <el-form-item label="会议主题" prop="Subject">
                <el-input v-model="form.Subject" maxlength="200" placeholder="请输入会议主题" />
              </el-form-item>
              <el-form-item label="开始时间" prop="StartTime">
                <el-date-picker v-model="form.StartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="开始时间" style="width: 100%;" :picker-options="bookingTimePickerOptions" />
              </el-form-item>
              <el-form-item label="结束时间" prop="EndTime">
                <el-date-picker v-model="form.EndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="结束时间" style="width: 100%;" :picker-options="bookingTimePickerOptions" />
              </el-form-item>
              <MeetingRoomParticipantPicker ref="participantPicker" v-model="participants"
                :school-id="schoolId" :room-id="form.RoomId || 0"
                :campus-id="bookingCampusId" :campus-name="bookingCampusName" />
              <MeetingRoomNotifyTypeField v-model="form.NotifyType" />
              <el-form-item label="备注">
                <el-input v-model="form.Remark" type="textarea" :rows="2" placeholder="可选" />
              </el-form-item>
            </el-form>
          </div>
          <div class="mr-booking-footer">
            <el-button @click="handleCancel">取消</el-button>
            <div class="mr-booking-footer__actions">
              <el-button @click="resetForm">重置</el-button>
              <el-button type="primary" :loading="submitLoading" @click="submitForm">确认代订</el-button>
            </div>
          </div>
        </div>
        <template v-else>
        <div class="mr-booking-body">
          <el-form ref="form" :model="form" :rules="formRules" label-width="100px" size="small"
            style="max-width: 680px;">
            <el-form-item label="会议室" prop="RoomId">
              <el-select v-model="form.RoomId" filterable placeholder="请选择会议室" style="width: 100%;"
                :loading="roomLoading" @visible-change="loadRooms">
                <el-option v-for="r in roomOptions" :key="r.Id" :label="roomOptionLabel(r)" :value="r.Id" />
              </el-select>
            </el-form-item>
            <el-form-item label="预约人" prop="BookerTeacherMasterId">
              <MeetingRoomTeacherSelect v-model="form.BookerTeacherMasterId" :department-id="schoolId" />
            </el-form-item>
            <el-form-item label="会议主题" prop="Subject">
              <el-input v-model="form.Subject" maxlength="200" placeholder="请输入会议主题" />
            </el-form-item>
            <el-form-item label="开始时间" prop="StartTime">
              <el-date-picker v-model="form.StartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="开始时间" style="width: 100%;" :picker-options="bookingTimePickerOptions" />
            </el-form-item>
            <el-form-item label="结束时间" prop="EndTime">
              <el-date-picker v-model="form.EndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="结束时间" style="width: 100%;" :picker-options="bookingTimePickerOptions" />
            </el-form-item>
            <MeetingRoomParticipantPicker ref="participantPicker" v-model="participants"
              :school-id="schoolId" :room-id="form.RoomId || 0"
              :campus-id="bookingCampusId" :campus-name="bookingCampusName" />
            <MeetingRoomNotifyTypeField v-model="form.NotifyType" />
            <el-form-item label="备注">
              <el-input v-model="form.Remark" type="textarea" :rows="2" placeholder="可选" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="submitLoading" @click="submitForm">提交</el-button>
              <el-button @click="resetForm">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        </template>
      </el-card>
    </section>
  </section>
</template>

<script>
import axios from 'axios';
import { BaseApiUrl } from '../../api/base';
import { resolveActiveSchoolId } from '../../utils/deptCascaderProps';
import {
  meetingBookingTimePickerOptions,
  createMeetingStartTimeRule,
  createMeetingEndTimeRule
} from '../../utils/meetingRoomForm';

const apiBase = BaseApiUrl;

export default {
  name: 'MeetingStandardBooking',
  props: {
    embedded: { type: Boolean, default: false }
  },
  components: {
    MeetingRoomTeacherSelect: () => import('../../components/MeetingRoomTeacherSelect.vue'),
    MeetingRoomParticipantPicker: () => import('../../components/MeetingRoomParticipantPicker.vue'),
    MeetingRoomNotifyTypeField: () => import('../../components/MeetingRoomNotifyTypeField.vue')
  },
  data() {
    return {
      form: {
        RoomId: null,
        BookerTeacherMasterId: null,
        Subject: '',
        StartTime: '',
        EndTime: '',
        Remark: '',
        NotifyType: 1
      },
      participants: [],
      bookingTimePickerOptions: meetingBookingTimePickerOptions,
      formRules: {
        RoomId: [{ required: true, message: '请选择会议室', trigger: 'change' }],
        BookerTeacherMasterId: [{ required: true, message: '请选择预约人', trigger: 'change' }],
        Subject: [{ required: true, message: '请输入会议主题', trigger: 'blur' }],
        StartTime: [
          { required: true, message: '请选择开始时间', trigger: 'change' },
          createMeetingStartTimeRule()
        ],
        EndTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' },
          createMeetingEndTimeRule(() => this.form.StartTime)
        ]
      },
      roomOptions: [],
      roomLoading: false,
      roomLoadedForSchool: null,
      submitLoading: false
    };
  },
  computed: {
    schoolId() {
      return resolveActiveSchoolId(this);
    },
    schoolName() {
      return this.$store.state.activeSchoolName || '';
    },
    selectedRoom() {
      return this.roomOptions.find(r => r.Id === this.form.RoomId) || null;
    },
    bookingCampusId() {
      return this.selectedRoom ? Number(this.selectedRoom.CampusId) || 0 : 0;
    },
    bookingCampusName() {
      return (this.selectedRoom && this.selectedRoom.CampusName) || '';
    }
  },
  watch: {
    schoolId(val, oldVal) {
      if (val === oldVal) return;
      this.roomOptions = [];
      this.roomLoadedForSchool = null;
      this.resetForm();
    }
  },
  methods: {
    roomOptionLabel(r) {
      if (r.Status === 1) return `${r.Name}（维护中）`;
      if (!r.IsOpenForBooking) return `${r.Name}（未开放）`;
      return r.Name;
    },
    loadRooms(visible) {
      if (!visible || !this.schoolId || this.roomLoading) return;
      if (this.roomLoadedForSchool === this.schoolId && this.roomOptions.length) return;
      this.roomLoading = true;
      axios.get(`${apiBase}/api/MeetingRoom/GetList`, {
        params: { page: 1, intPageSize: 200, departmentId: this.schoolId }
      }).then(res => {
        this.roomLoading = false;
        this.roomLoadedForSchool = this.schoolId;
        this.roomOptions = (res.data.success && res.data.response && res.data.response.data) || [];
      }).catch(() => { this.roomLoading = false; });
    },
    buildParticipants() {
      const picker = this.$refs.participantPicker;
      return picker ? picker.buildPayload() : [];
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.submitLoading = true;
        axios.post(`${apiBase}/api/MeetingBooking/Create`, {
          ...this.form,
          Participants: this.buildParticipants()
        }).then(res => {
          this.submitLoading = false;
          if (res.data.success) {
            this.$message.success(res.data.msg || '创建成功');
            this.resetForm();
            this.$emit('success');
          } else {
            this.$message.error(res.data.msg || '创建失败');
          }
        }).catch(() => { this.submitLoading = false; });
      });
    },
    resetForm() {
      this.form = {
        RoomId: null,
        BookerTeacherMasterId: null,
        Subject: '',
        StartTime: '',
        EndTime: '',
        Remark: '',
        NotifyType: 1
      };
      this.participants = [];
      if (this.$refs.participantPicker) this.$refs.participantPicker.reset();
      if (this.$refs.form) {
        this.$nextTick(() => this.$refs.form.clearValidate());
      }
    },
    handleCancel() {
      this.$emit('cancel');
    }
  }
};
</script>
